module.exports = '<svg width="38" height="32" viewBox="0 0 38 32"><path d="M38.397 10.989v10.026c0 .922-.806 1.386-1.706 1.386H22.397v8.637c0 .925-.79 1.238-1.53.701L.573 16.974c-.733-.538-.778-1.408-.048-1.946L20.896.263c.733-.538 1.501-.224 1.501.701v8.637h14.294c.899 0 1.706.464 1.706 1.389z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/left-arrow-1.js
// module id = 1218
// module chunks = 14